import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AppSettings } from "src/app/shared/AppSettings";
import { BillPayStatus, tConsultHeadModelWithPatientInfo } from "src/app/models/tConsultHeadModel";
import { tOnConsultService } from "src/app/services/tOnConsult.service";
import { isNullOrUndefined } from "util";
import { PathAction } from "src/app/models/non-master-model/PathAction";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";


@Component({
  selector: 'app-bill-summary-dialog',
  templateUrl: './bill-summary-dialog.component.html',
  styleUrls: ['./bill-summary-dialog.component.css']
})
export class BillSummaryDialogComponent implements OnInit {
  dataList = [];
  discount: number = 0;
  totalPrice: number = 0;
  onConsultDataList: tConsultHeadModelWithPatientInfo;
  inputDisabled = true;
  outStanding:number=0;
  @Input() clthShopID:string;
  @Input() clthConsultNumber:string;
  @Input() remark:string;
  diagnosis:string = "";

  constructor(
    public activeModal:NgbActiveModal,
    private router: Router,
    private tOnConsultService: tOnConsultService,
  ) {}

  ngOnInit() {
    this.onConsultDataList = JSON.parse(localStorage.getItem("onConsultModel"));

    this.dataList = [
      { id: 1, desc: "bill_summary_title_1", amount: 0, cost: 0, detail: "" },
      { id: 2, desc: "bill_summary_title_2", amount: 0, cost: 0.00, detail: "" },
      { id: 3, desc: "bill_summary_title_3", amount: 0, cost: 0, detail: "" },
      { id: 4, desc: "bill_summary_title_4", amount: 0, cost: 0, detail: "" },
      { id: 5, desc: "bill_summary_title_5", amount: 0, cost: 0, detail: "" },
      { id: 6, desc: "bill_summary_title_6", amount: 0, cost: 0, detail: "" },
      { id: 7, desc: "bill_summary_title_7", amount: 0, cost: 0, detail: "" },
      { id: 8, desc: "bill_summary_title_8", amount: 0, cost: 0, detail: "" },
    ];
    this.getOnConsultInfo();
    this.getData();
  }

  getOnConsultInfo() {
    // tslint:disable-next-line:max-line-length
    this.tOnConsultService
      .getOnConsultInfo(
        this.clthShopID,
        this.clthConsultNumber
      )
      .subscribe((data) => {
        this.onConsultDataList = data[0];

        this.diagnosis = this.onConsultDataList.clthDiagonsis;

        this.inputDisabled = false;
        if (!isNullOrUndefined(this.onConsultDataList.clthBillingStatus)) {
          if (
            this.onConsultDataList.clthBillingStatus !==
            BillPayStatus.WaitingAction
          ) {
            this.inputDisabled = true;
          }
        }

        // if (this.onConsultDataList.clthBedNumber === null) {
        //   this.inputDisabled = true;
        // }

      });
  }

  getData() {
    this.tOnConsultService.summary(this.clthShopID, this.clthConsultNumber).subscribe((x) => {
      console.log(JSON.stringify(x));
      if(x!=null){
        this.outStanding=x.outstanding;
      }
      const titles = [
        "consultations",
        "prescriptions",
        "physioAndOrthotics",
        "labAndImagings",
        "xrays",
        "procedures",
        "others",
        "discount",
      ];

      for (let i = 0; i < titles.length; i++) {
        console.log('this.dataList[i] = '+JSON.stringify(this.dataList[i]));
        if (x[titles[i]].length == 0) continue;
        this.dataList[i].amount = x[titles[i]]
          .map((x) => x.amount)
          .reduce((a, b) => a + b, 0);
        this.dataList[i].cost = (x[titles[i]]
          .map((x) => x.cost)
          .reduce((a, b) => a + b, 0)).toFixed(2);
        this.dataList[i].detail = x[titles[i]]
          .map((x) => x.itemDesc)
          .join(" , ");
        console.log("this.dataList[i].detail = " + this.dataList[i].detail);
      }

      this.sumDataList();
    });
  }

  editInput(element: any, value: number) {
    element.price = value;
    this.sumDataList();
  }
  editDiscount(value: number) {
    console.log('editDiscount = '+value);
    if(value === null) value = 0;
    this.discount = value;
    this.sumDataList();
  }

  sumDataList() {
    this.totalPrice = 0;

    this.totalPrice += this.dataList
      .map((x) => Number(x.amount))
      .reduce((a, b) => a + b, 0);

    // for(let i=0;i<this.dataList.length;i++){
    //   this.totalPrice+=parseFloat(this.dataList[i].amount.toString());
    // }
    this.totalPrice -= this.discount;
  }

  back() {
    if (!isNullOrUndefined(localStorage.getItem("action"))) {
      if (localStorage.getItem("action") === PathAction.fromPatientHistory) {
        this.router.navigate([AppSettings.Path_PatientHistory]);
      }

      if (localStorage.getItem("action") === PathAction.fromOutstandingBill) {
        this.router.navigate([AppSettings.Path_Outstanding]);
      }

      if (localStorage.getItem("action") === PathAction.fromVoidVoucher) {
        this.router.navigate([AppSettings.Path_VoidVoucher]);
      }

      if (localStorage.getItem("action") === PathAction.fromPatientMaster) {
        this.router.navigate([
          AppSettings.Path_tPatient +
            AppSettings.PATH_EDIT +
            AppSettings.Path_PatientMasterHistory,
        ]);
      }

      if (
        localStorage.getItem("action") === PathAction.fromVoidVoucherBackday
      ) {
        this.router.navigate([
          AppSettings.Path_VoidVoucher + AppSettings.Path_VoidVoucherBackDay,
        ]);
      }
      if (localStorage.getItem("action") === PathAction.fromHistoryBackday) {
        this.router.navigate([AppSettings.Path_historyByDate]);
      }
      if (localStorage.getItem("action") === PathAction.fromXray) {
        this.router.navigate([AppSettings.Path_Xray]);
      }
      if (localStorage.getItem("action") === PathAction.fromPhysio) {
        this.router.navigate([AppSettings.Path_Physio]);
      }
    } else {
      this.router.navigate([AppSettings.Path_tConsultHead_Waiting]);
    }

    // this.router.navigate([AppSettings.Path_tConsultHead_Waiting]);

    // let backToOutStandingList = false;
    // if (!isNullOrUndefined(this.onConsultDataList.clthBillingNumber)) {
    //   if (this.onConsultDataList.clthBillingNumber !== '') {
    //     backToOutStandingList = true;
    //   }
    // }

    // if (backToOutStandingList) {
    //   this.router.navigate([AppSettings.Path_Outstanding]);
    // } else {
    //   this.router.navigate([AppSettings.Path_tConsultHead_Waiting]);
    // }
  }

  confirm(){
    this.activeModal.close('Y');
  }
}
